import React, { useState } from "react";
import emailjs from "@emailjs/browser";
import "../Css/Contact-Forum.css"

const ContactForm = () => {
    const [formData, setFormData] = useState({ name: "", email: "", message: "", Comp: "" });
    const [status, setStatus] = useState("");

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        emailjs.send(
            "service_7942mo7",  // Replace with your EmailJS Service ID
            "template_gvkwf6e", // Replace with your EmailJS Template ID
            formData,
            "stbvqEK9ZBVlNxcyU"   // Replace with your EmailJS Public Key
        ).then(response => {
            console.log("Email enviado Correctamente", response);
            setStatus("Email enviado Correctamente");
            setFormData({ name: "", email: "", message: "", Comp: "" }); // Reset form data
            setTimeout(() => setStatus(""), 2000);
        }).catch(error => {
            console.error("Email error", error);
            setStatus("");

        });
    };

    return (
        <div className="forum-wrapper">
            <div className={`contact-form ${status === "Email enviado Correctamente" ? "success" : ""}`}>

                <div className="contact-form">
                    <h2 className="titlecontact">Contacto</h2>
                    {/* {status && <p>{status}</p>} */}
                    <form onSubmit={handleSubmit}>
                        <input type="text" name="name" placeholder="Nombre" value={formData.name} onChange={handleChange} />
                        <input type="email" name="email" placeholder="Email" value={formData.email} onChange={handleChange} required />
                        <input type="text" name="Comp" placeholder="Empresa / Negocio / Marca" value={formData.Comp} onChange={handleChange} />
                        <textarea name="message" placeholder="Mensaje" value={formData.message} onChange={handleChange} required />
                        <button type="submit">Enviar</button>
                    </form>
                </div>
            </div>
        </div>
    );

};

export default ContactForm;
